import React from 'react';
import TopBar from '../Header/TopBar';
import Header from '../Header/Header';
import Hero from '../Hero/Hero';
import WelcomeSection from '../WelcomeSection/WelcomeSection';
import './App.css';
import MapSection from '../MapSection/MapSection';
import InfoBadges from '../InfoBadges/InfoBadges';
import Testimonials from '../Testimonials/Testimonials';
import { OurServices } from '../OurServices/OurServices';
import PhotoHighlights from '../PhotoHighlights/PhotoHighlights';
import Footer from '../Footer/Footer';
import FAQ from '../FAQ/FAQ';
import ContactForm from '../ContactForm/ContactForm';
import OurPartners from '../Partners/Partners';
import OurTeam from '../OurTeam/OurTeam';

const App: React.FC = () => {
  return (
    <div className="App">
      <TopBar />
      <Header />
      <Hero />
      <div className='width-container'>
        <WelcomeSection/>
        <MapSection/>
        <InfoBadges/>
        <OurPartners/>
        <OurServices/>
        <PhotoHighlights/>
        <ContactForm/>
        <OurTeam/>
      </div>
      <FAQ/>
      <Footer/>
    </div>
  );
};

export default App;
